/**
 * Format number by decimal and thousand separators
 * @param  {Number} number              The number to be formatted.
 * @param  {Number} decimals_quantity   The amount of decimals.
 * @param  {String} decimal_point       The character that will represent the decimal point.
 * @param  {String} thousands_separator The character that represents the thousands separator.
 * @return {String}                     The number formatted by the thousands separator and by decimals.
 */
const numberFormat = (number = 0, decimals_quantity = 2, decimal_point = '.', thousands_separator = ',') => {
    const roundedNumber = Number(number.toFixed(decimals_quantity));
    const str = decimals_quantity > 0 ? roundedNumber.toString().split('.') : roundedNumber.toString().split('.');
    let parts = [];
    for (let i = str[0].length; i > 0; i -= 3) {
        parts = [str[0].substring(Math.max(0, i - 3), i), ...parts];
    }
    str[0] = parts.join(thousands_separator);
    if (str[1]) {
        str[1] = str[1].substring(0, decimals_quantity);
    }
    return str.join(decimals_quantity > 0 ? decimal_point : '');
}

export default numberFormat;